import AbstractDataAdapter from './AbstractDataAdapter';

class ManufacturerDataAdapter extends AbstractDataAdapter {
  /**
   *
   * @returns {string[]}
   */
  static get allowedFields() {
    return ['name'];
  }

  /**
   *
   * @returns {string[]}
   */
  static get requiredFields() {
    return ['name'];
  }
}

export default ManufacturerDataAdapter;
